import { IWidgetDefinition, IWidget } from '../../common/core';
import { FuseTextFacetData, FuseTextFacetWidgetDefinition } from '../fuse-textfacet.widget/fuse-textfacet';
import { IFuseTextFacetState } from '../fuse-textfacet.widget/settings';
import { IFuseDateRangeSettings } from './settings'

class FuseDateRangeData extends FuseTextFacetData {

  constructor(public widget: IWidget<FuseDateRangeData, IFuseDateRangeSettings, IFuseTextFacetState>) {
    super(widget);
  }

  digits = Array<number>(10).reduce((res, item) => {
    res[item] = 1;
    return res;
  }, {});

  getField() {
    var f = super.getField();
    var rRanges = this.getRanges().map(function (r) {
      return r.r;
    }).filter(function (x) {
      return x;
    });

    return `${f}@ranges:${rRanges.join('|')}`;
  }

  getSelectedQuery(): string {
    var sel = this.getSelArray(true);

    if (sel && sel.length) {
      var queryParts = [];
      sel.forEach((term, ti) => {
        var ps = term.split('|');
        var from = ps[0];
        if (from == 'x') {
          from = null;
        }
        var to = ps[1];
        if (to == 'x') {
          to = null;
        }

        if (from) {
          var fromQ = this.widget.s.helpers.formatQueryPart(this.fieldWithoutAt, from, '>=');
          queryParts.push(fromQ);
        } else if (to) {
          var toQ = this.widget.s.helpers.formatQueryPart(this.fieldWithoutAt, to, '<=');
          queryParts.push(toQ);
        }
      });

      if (queryParts.length) {
        var q = queryParts.join(' OR ');
        if (queryParts.length > 1) {
          q = '(' + q + ')';
        }
        return q;
      }
    }
  }

  getRanges() {
    var format = 'yyyy-MM-dd';
    var now = new Date().getTime();
    var ranges = this.widget.settings.ranges.map(r => {
      var d = r.d;
      if (!d) {
        return {
          l: r.l
        }
      }

      var dateSign = '';
      var dateNum = '';
      var dateLet = '';
      d.split('').forEach(c => {
        if (c) {
          var cNum = parseInt(c);
          if (!isNaN(cNum)) {
            dateNum += c;
          } else if ((c == '-' || c == '+') && !dateNum && !dateLet) {
            dateSign = c;
          } else if (!dateLet) {
            dateLet = c;
          }
        }
      });
      var sign = dateSign == '-' ? -1 : 1;

      var date;
      if (dateNum) {
        var dn = parseInt(dateNum);
        if (!isNaN(dn)) {
          switch (dateLet) {
            case 'm': // minutes
              date = new Date(now + dn * 60 * 1000 * sign);
              break;
            case 'h': // hours
              date = new Date(now + dn * 60 * 60 * 1000 * sign);
              break;
            case 'd': // days
              date = new Date(now + dn * 24 * 60 * 60 * 1000 * sign);
              break;
            case 'M': // months
              date = new Date(now);
              date.setMonth(date.getMonth() + dn * sign);
              break;
            case 'y': // years
              date = new Date(now);
              date.setMonth(date.getMonth() + dn * 12 * sign)
              break;
          }
        }
      }

      return {
        l: r.l,
        d: date,
        r: date ? this.widget.s.sharedServices.format.date(date, format) : null
      };
    });

    ranges.sort((a, b) => {
      var ad = a.d;
      var bd = b.d;
      if (!ad) {
        return -1;
      }
      if (!bd) {
        return 1;
      }
      return ad > bd ? 1 : -1;
    });

    return ranges;
  }

  adjustFacets(terms: { count: number, term: string, label?: string }[], moreFilter?: string) {
    var ranges = this.getRanges();

    var fromMap = ranges.reduce(function (res: any, it) {
      if (it['r']) {
        res[new Date(it['r']).getTime()] = it;
      } else {
        res[''] = it;
      }
      return res;
    }, {});

    terms.sort(function (a, b) {
      var af = a['from'];
      var bf = b['from'];
      if (!af) {
        return 1;
      }
      if (bf) {
        return -1;
      }
      return af > bf ? 1 : -1;
    });

    var sums = 0
    terms.forEach(function (term, ti) {
      var key = term['from'] ? new Date(term['from']).getTime() : '';
      var item = fromMap[key];
      if (item) {
        term['item'] = item;
        term.label = item.l;

        var count = term.count;
        if (item.d) {
          term.count += sums;
          sums += count;
        }
      }
    });

    return super.adjustFacets(terms, moreFilter);
  }
};

export const FuseDateRangeWidgetDefinition: IWidgetDefinition<FuseDateRangeData, IFuseDateRangeSettings, IFuseTextFacetState> = {
  ...FuseTextFacetWidgetDefinition,
  init(widget) {
    widget.data = new FuseDateRangeData(widget);
  }
};
